/* Native details keep the staging navigation usable without JavaScript. */
document.addEventListener('click', (event) => {
  document.querySelectorAll('.go-nav-disclosure[open]').forEach((disclosure) => {
    if (!disclosure.contains(event.target)) disclosure.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.go-nav-disclosure[open]').forEach((disclosure) => {
    if (disclosure.contains(document.activeElement)) disclosure.querySelector('summary').focus();
    disclosure.open = false;
  });
});
document.addEventListener('toggle', (event) => {
  if (!event.target.matches('.go-nav-disclosure') || !event.target.open) return;
  document.querySelectorAll('.go-nav-disclosure[open]').forEach((disclosure) => {
    if (disclosure !== event.target) disclosure.open = false;
  });
}, true);
